import type { ReactNode } from "react";

type QuoteFieldProps = {
  label: string;
  htmlFor?: string;
  children: ReactNode;
};

export function QuoteField({ label, htmlFor, children }: QuoteFieldProps) {
  return (
    <label className="fx-q-lab" htmlFor={htmlFor}>
      <span>{label}</span>
      {children}
    </label>
  );
}
